import { jsx as _jsx } from "react/jsx-runtime";
import FlyoutAsideContext from '../../provider/FlyoutAsideContext';
import { NavigationFlyoutAsideElement } from './styles/navigation-flyout-aside.styled';
export const NavigationFlyoutAside = ({ children }) => {
    return (_jsx(FlyoutAsideContext.Provider, { value: true, children: _jsx(NavigationFlyoutAsideElement, { children: children }) }));
};
